<template>

  <div class="selected pb-4">
    <div class="row align-items-center mb-4">
      <div class="col">
        <h2>{{ $t("roomSelection") }} {{ roomIndex }}</h2>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary btn-small" @click="
          unselectRoom(
            Object.values($attrs.prices)[0],
            Object.keys($attrs.prices)[0]
          )
        ">
          {{ $t("remove") }}
        </button>
      </div>
    </div>
    <div class="room" :id="code">
      <div class="room-body row mr-0 ml-0">
        <div class="col-sm-6 col-lg-5 col-xl-4 p-0">
          <div class="image-gallery">
            <img :src="$attrs.mediums[0]" class="img-fluid" />
          </div>
        </div>
        <div class="col-sm-6 col-lg-7 col-xl-8">
          <div class="room-description">
            <div class="row">
              <div class="col-12">
                <h4 class="mb-4">{{ name }} </h4>
              </div>
              <div class="col-12">
                <p v-if="nights == 1" class="mb-2">
                  {{ $t("price-for") }} {{ nights }} {{ $t("night") }}&nbsp;
                </p>
                <p v-else class="mb-2">
                  {{ $t("price-for") }} {{ nights }} {{ $t("nights") }}&nbsp;
                </p>
                <!-- <p class="mb-2">{{ toPrice($attrs.selectedprice.price) }} </p> -->
                <p >
                  {{ adults }}
                  <span v-if="adults == 1">
                    {{ $t("adult") }}
                  </span>
                  <span v-else>
                    {{ $t("adults") }} </span>:
                  {{
                      toPrice($attrs.prices[$attrs.selectedprice.rateplan].adult)
                  }}

                  <span v-if="$attrs.prices[$attrs.selectedprice.rateplan].ch3">
                    <br />{{ age3calc }}
                    <span v-if="age3calc == 1">{{ $t("child") }} </span>
                    <span v-else> {{ $t("children") }} </span>
                    {{ writeChildrenAges(age3text) }}: {{ toPrice($attrs.prices[$attrs.selectedprice.rateplan].ch3) }}
                  </span>

                  <span v-if="$attrs.prices[$attrs.selectedprice.rateplan].ch8">
                    <br />{{ age8calc }}
                    <span v-if="age8calc == 1">{{ $t("child") }}</span>
                    <span v-else>{{ $t("children") }} </span>
                    {{ writeChildrenAges(age8text) }}: {{ toPrice($attrs.prices[$attrs.selectedprice.rateplan].ch8) }}
                  </span>

                  <span v-if="$attrs.prices[$attrs.selectedprice.rateplan].ch14">
                    <br />{{ age14calc }}
                    <span v-if="age14calc == 1"> {{ $t("child") }}</span>
                    <span v-else>{{ $t("children") }} </span>
                    {{ writeChildrenAges(age14text) }}: {{ toPrice($attrs.prices[$attrs.selectedprice.rateplan].ch14) }}
                  </span>
                  <!-- <a class="more-info" @click="additionalInfoOpen = !additionalInfoOpen" v-if="childrenages !== ''">
                    <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.00002 12.8333C10.2217 12.8333 12.8334 10.2216 12.8334 6.99996C12.8334 3.7783 10.2217 1.16663 7.00002 1.16663C3.77836 1.16663 1.16669 3.7783 1.16669 6.99996C1.16669 10.2216 3.77836 12.8333 7.00002 12.8333Z"
                        stroke="#A34F8B" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M7 9.33333V7" stroke="#A34F8B" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M7 4.66663H7.00667" stroke="#A34F8B" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </a> -->
                </p>
                <AgeTable v-if="additionalInfoOpen && childrenages" @closeClicked="closeAdditionalInfo"></AgeTable>
              </div>
              <!--
              <div class="col-6 text-right text-end">
                <span>
                  {{ adults }} {{ $t("adults") }}
                  <span v-if="childrenages">
                    / {{ $t("children") }}
                    {{ childrenages }}
                  </span>
                </span>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>


<script>
import AgeTable from "./AgeTable.vue";

export default {
  name: "SelectedListItem",
  components: {
    AgeTable,
  },
  props: {
    nights: Number,
    name: String,
    teaser: String,
    code: String,
    visible: Boolean,
    selected: Boolean,
    adults: String,
    childrenages: Array,
    apikey: String,
    roomIndex: Number,
  },
  data() {
    return {
      age3: 0,
      age8: 0,
      age14: 0,
      age3text: [],
      age8text: [],
      age14text: [],
      price: null,
      rateplan: null,
      openText: this.$t("prices-packages-show"),
      closeText: this.$t("prices-packages-hide"),
      additionalInfoOpen: false,
    };
  },
  created() {
    this.rateplan = this.$attrs.selectedprice.rateplan;
    console.log(this.rateplan);
  },
  watch: {
    additionalInfoOpen: function () {
      if (this.additionalInfoOpen) {
        document.body.classList.add("info-open");
      } else {
        document.body.classList.remove("info-open");
      }
    },
  },
  computed: {
    isSelected() {
      return this.selected;
    },
    isOpenText() {
      return this.$t("price-from");
    },

    children3() {
      return 1
    },

    age3calc() {
      this.childrenages.split(";").forEach((age) => {
        if (age < 4) {
          this.age3text.push(age);
          this.age3++;
        }
      });
      return this.age3;
    },
    age8calc() {
      this.childrenages.split(";").forEach((age) => {
        if (3 < age && age < 9) {
          this.age8text.push(age);
          this.age8++;
        }
      });
      return this.age8;
    },
    age14calc() {
      this.childrenages.split(";").forEach((age) => {
        if (9 < age) {
          this.age14text.push(age);
          this.age14++;
        }
      });
      return this.age14;
    },
  },
  methods: {

    checkIfThereIsOnlyOnes(arr) {
      arr.sort();
      if (arr[0] == 1) {
        // if first nd last element is the same
        return arr[0] == arr[arr.length - 1]
      }
    },

    writeChildrenAges(ages) {
      if (this.checkIfThereIsOnlyOnes(ages)) {
        return ages.join(" " + this.$t("and"))   + " " +  this.$t("year")
      } else {
        return ages.join(" " + this.$t("and"))  + " " +  this.$t("years")
      }
    },
    unselectRoom() {
      var params = this.apikey;
      this.$emit("unselectRoom", params);
    },
    closeAdditionalInfo() {
      this.additionalInfoOpen = false;
    },
  },
};
</script>